import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {CalculationGoldFormUpsertRequest, CalculationGoldListElement} from './calculation-gold.models';
import {queryKey} from './calculation-gold-querykeys';

export function useCalculationGoldCreateMutation(): UseMutationResult<CalculationGoldListElement> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (form: CalculationGoldFormUpsertRequest) =>
      AxiosHttpClient.post<CalculationGoldListElement>(
        `${environment.apiv4uri}calculation/gold`,
        form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.list()});
    },
  });
}
